import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment'
import { Router } from '@angular/router';
import { SettingsSyncService } from './api/settings-sync.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated = false; // Cached authentication state

  constructor(private http: HttpClient,private router: Router, private settingsSync: SettingsSyncService) {}

  /**
   * Checks if the session is valid.
   * Uses cache if already authenticated.
   */
  checkSession(): Observable<boolean> {
    let endpoint = environment.APIEndpoint
    if(!window.location.hostname.includes("localhost")) endpoint = environment.APIEndpointPROD;
    if (this.isAuthenticated) {
      return of(true);
    }

    return this.http.get(endpoint+'auth', { withCredentials: true }).pipe(
      // Signed in: load the user's saved settings back into cookies before any page reads them. This never fails, so it
      // can't turn a good session into a failed one.
      switchMap(() => from(this.settingsSync.RestoreOnce())),
      map(() => {
        this.isAuthenticated = true;
        return true;
      }),
      catchError(() => {
        this.isAuthenticated = false;
        return of(false);
      })
    );
  }




  /**
   * Logs the user out and clears authentication state.
   */
  // reason: a fixed code (not free text) looked up against login.page.ts's own hardcoded message
  // table - explains an involuntary logout (e.g. the session expired from inactivity) without
  // letting the URL dictate arbitrary text shown on the login page.
  logout(reason?: string): void {
    console.log("Logging out, clearing session on server...");
    this.isAuthenticated = false;
    // Save any settings changes that haven't gone up yet, then forget this user - the cookie wipe below removes every
    // setting from this browser, and the next sign in loads them back from the server.
    this.settingsSync.FlushNow();
    this.settingsSync.ForgetRestored();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    const query = reason ? `?reason=${encodeURIComponent(reason)}` : '';
    window.location.href = '/login' + query;
  }

  isAuthenticatedCheck(): boolean {
    return this.isAuthenticated;
  }
  
  RedirectToLogin() {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    console.log("Redirecting to login page. Is localhost:", isLocalhost, "Current URL:", window.location.href);
    const redirectUrl = encodeURIComponent(window.location.href);
    if (isLocalhost) {
      this.router.navigate(['/login'], { queryParams: { redirect_url: redirectUrl } });
    } else {
      window.location.href = `https://fusionworkflow.com/login.html?redirect_url=${redirectUrl}`;
    }
  }
}
